import React, {useEffect, useState} from 'react';
import {initial} from '../domain/RemoteData.model';
import {remoteDataWithSetter} from '../utils/remoteDataWithSetter';
import {RemoteDataUI} from './RemoteDataUI';
import {Swiper} from './Swiper';
import {CatalogItemCard} from './CatalogItemCard';
import {Spinner} from 'react-bootstrap';
import {Price} from "./Price";

export const ProductSwiper = ({ title, fetchFn }) => {
  const [productsRemoteData, setProductsRemoteData] = useState(initial([]));

  useEffect(() => {
    if (!!fetchFn) {
      remoteDataWithSetter(setProductsRemoteData, fetchFn).then();
    }
  }, [fetchFn]);

  return (
    <RemoteDataUI remoteData={productsRemoteData}>
      <RemoteDataUI.Success>
        {
          products => products.length === 0 ? null : (
            <div className="row">
              <div className="col-12 align-self-start">
                <div className="border-start border-4 border-primary ps-3 mb-2">
                  <p className="fw-bolder text-primary fs-5 mb-0">{title}</p>
                </div>
              </div>
              <div className="col-12 p-3 rounded-2">
                <Swiper>
                  {
                    products.map((product, index) => (
                      <Swiper.Item key={index}>
                        <CatalogItemCard data={{ catalogItem: product }}>
                          <CatalogItemCard.Price>
                            <Price data={{sellingPrice: product.price?.bestPrice, basePrice: product.price?.value}}/>
                          </CatalogItemCard.Price>
                        </CatalogItemCard>
                      </Swiper.Item>
                    ))
                  }
                </Swiper>
              </div>
            </div>
          )
        }
      </RemoteDataUI.Success>
      <RemoteDataUI.Pending>
        <div className="text-center m-4"><Spinner /></div>
      </RemoteDataUI.Pending>
      <RemoteDataUI.Failure>
        <div className="alert alert-danger">Imposible cargar productos.</div>
      </RemoteDataUI.Failure>
    </RemoteDataUI>
  );
};